<div class="form-input-card">
  <p-message severity="secondary"> {{ title }}</p-message>

  <div style="text-align: center; padding: 1rem">
    <i style="font-size: 4rem; color: #ff0040" class="pi {{ piIcon }}"></i>
  </div>

  <div>{{ message }} </div>

  @if (warning) {
    <p-message severity="warn">
      <i class="pi pi-exclamation-triangle"></i>
      {{ warning }}</p-message
      >
    }

    <br /><br />

    <div>
      <div style="float: right">
        @if (oneBotton) {
          <p-button label="Ok" (click)="confirm()"></p-button>
        }
      </div>

      @if (!oneBotton) {
        <div class="options">
          <p-button [label]="cancelText" (click)="cancel()" severity="secondary"></p-button>
          <p-button [label]="acceptText" (click)="confirm()" severity="danger"></p-button>
        </div>
      }
    </div>
  </div>
